import React, {useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {CLARITY_UNMASK} from '../../utils/clarity/unmask';
import {TrialCodeForm, TrialCodeSuccess} from './TrialCodeForm';

/** El código de prueba desde el banner: el campo, y el «Listo» con la fecha nueva. */
export function TrialCodeModal({isOpen, onClose, onRedeemed}) {
    const {t} = useTranslation();
    const [redeemed, setRedeemed] = useState(null);

    const handleRedeemed = (data) => {
        setRedeemed(data);
        if (onRedeemed) onRedeemed(data);
    };

    const handleClosed = () => setRedeemed(null);

    return (
        <Modal isOpen={isOpen} toggle={onClose} onClosed={handleClosed} centered className="trial-code-modal">
            <ModalHeader toggle={onClose} {...CLARITY_UNMASK}>{t('trial_code.modal_title')}</ModalHeader>
            <ModalBody>
                {redeemed ? (
                    <TrialCodeSuccess data={redeemed}/>
                ) : (
                    <>
                        <p className="trial-code-modal__text" {...CLARITY_UNMASK}>{t('trial_code.modal_text')}</p>
                        <TrialCodeForm onRedeemed={handleRedeemed} autoFocus idPrefix="trial-code-modal"/>
                    </>
                )}
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary -alt -negative" onClick={onClose} {...CLARITY_UNMASK}>
                    {redeemed ? t('trial_code.close') : t('trial_code.cancel')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
